module.exports = __webpack_public_path__ + "media/images/logo_avatar_thumb-24cf74f5047d62b217bbd62665d02a20.png";